import {
  Animatespin,
  Navbar,
  MainHeading,
  Experience,
  Footer,
  HoverButton,
  JobsCom,
} from "../../components/index";
import Functions from "./index.function.js";
export default function AppliedApplication() {
  const {
    isLoading,
    jobsApplied,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    handleJobClick,
    JobsthemeColorsData,
  } = Functions();
  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:py-5">
        <MainHeading
          title={"Applied Application"}
          dis={" "}
          layout={"h-18 sm:h-20 lg:h-36"}
          navigate={"/job-listing"}
        />
        {!isLoading &&
          jobsApplied?.pages?.flatMap((page) => page?.job_applies || [])
            .length === 0 && (
            <div className="flex justify-center items-center w-full py-10">
              <p className="text-lg text-gray-500">No applied jobs found.</p>
            </div>
          )}

        <div className="lg:mt-8 lg:pt-14 xs:pt-5 sm:py-6 grid xs:grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 xs:gap-y-3 sm:gap-5 xl:gap-7 3xl:gap-12">
          {jobsApplied?.pages?.flatMap((page) =>
            page?.job_applies?.map((apply, index) => (
              <div key={apply?.job?.id || index}>
                <JobsCom
                  onClick={() => handleJobClick(apply?.job?.id)}
                  subtitle={apply?.job?.company?.name}
                  jobsTitle={apply?.job?.title}
                  jobsDis={(apply?.job?.description?.split(".")[0] || "") + "."}
                  timingbtnTitle={
                    apply?.job?.job_types?.job_type ?? "Full Time"
                  }
                  salarybtnTitle={`${apply?.job?.salary_currency ?? ""}${
                    apply?.job?.salary_from
                  } - ${apply?.job?.salary_currency ?? ""}${
                    apply?.job?.salary_to
                  }`}
                  jobstheme={
                    JobsthemeColorsData[index % JobsthemeColorsData?.length]
                      .jobstheme
                  }
                  btntheme={
                    JobsthemeColorsData[index % JobsthemeColorsData?.length]
                      .btntheme
                  }
                  location={apply?.job?.country?.country ?? "Pakistan"}
                  isApplied={apply?.job?.id}
                  statusbg={
                    JobsthemeColorsData[index % JobsthemeColorsData?.length]
                      .btntheme
                  }
                  status={apply?.status}
                  statusLayout="xs:w-44 sm:w-48 lg:w-56"
                />
              </div>
            ))
          )}
        </div>
        {isFetchingNextPage || isLoading ? (
          <div className="pt-4">
            <Animatespin />
          </div>
        ) : (
          hasNextPage && (
            <div className="flex justify-center items-center pt-20">
              <HoverButton
                onClick={() => fetchNextPage()}
                extraClasses="group xs:w-56 xs:h-8 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                BtnTitle="Load More Talent"
                BtnTitleClasses="text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
              />
            </div>
          )
        )}
      </div>
      <Experience />
      <Footer />
    </div>
  );
}
